import { ApiClientError, GetLibrary } from '@raydiant/api-client-js';
import { keys } from '../queryClient';
import raydiant from '../clients/miraClient';
import useProtectedQuery from './useProtectedQuery';
import { getQueryString, LibraryQueryParams } from '../pages/LibraryPage/utils';
import { UseQueryOptions } from 'react-query';

export default function useLibrary(
  query: LibraryQueryParams,
  options: UseQueryOptions<GetLibrary, ApiClientError> = {},
) {
  const queryString = getQueryString(query);

  return useProtectedQuery<GetLibrary, ApiClientError>(
    keys.library(query),
    () => raydiant.getLibrary(queryString),
    {
      enabled: true,
      ...options,
    },
  );
}
